import React, { useState } from "react";
import { Row, Col, Form, Input, Card } from "antd";
import axiosInstance from "../../axios";
import config from "../../config";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

export default function ChangePassword() {
    const general = useGeneralStore();
    const [newpassword, setnewpassword] = useState('');
    const [confirm, setconfirm] = useState('');
    const { auth } = usePersistedStore();
    const loading = auth.loading;

    function onFinish(values) {
        async function changePassword(values) {
            try {
                await axiosInstance({
                    method: 'post',
                    baseURL: config.apiUrls(),
                    url: '/v1/authentication/change-password',
                    data: {
                        OldPassword: values.password,
                        NewPassword: values.newPassword
                    }
                });
                general.NotifSuccess('رمز عبور با موفقیت تغییر یافت')
            } catch (error) {
                console.log('error', error)
            }
        }
        changePassword(values)
    }

    return (
        <Row gutter={16} justify="space-around" style={{ paddingTop: 20 }}>
            <Col span={14}>
                <Card size="small" >
                    <Form onFinish={onFinish}>
                        <Form.Item label="کلمه عبور فعلی"
                            name="password"
                            rules={[{ required: true, message: 'لطفا کلمه عبور فعلی خود را وارد کنید' }]}>
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="newPassword"
                            label="کلمه عبور جدید"
                            rules={[
                                { required: true, message: 'لطفا کلمه عبور جدید را وارد نمایید' },
                            ]}
                            hasFeedback>
                            <Input.Password onChange={(ev) => setnewpassword(ev.target.value)} value={newpassword} />
                        </Form.Item>
                        <Form.Item
                            name="confirm"
                            label="تایید کلمه عبور"
                            dependencies={['newPassword']}
                            hasFeedback
                            rules={[
                                { required: true, message: 'لطفا کلمه عبور جدید خود را دوباره وارد نمایید' },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('کلمه عبور جدید با تکرار کلمه عبور جدید یکسان نمی باشند');
                                    },
                                }),
                            ]}>
                            <Input.Password onChange={(ev) => setconfirm(ev.target.value)} value={confirm} />
                        </Form.Item>
                        <p style={{ color: (newpassword.length >= 7 && confirm.length >= 7) ? "#04d507" : "#d50404" }} className="description">کلمه عبور حداقل 7 کاراکتر باشد. </p>
                        <Form.Item>
                            <button
                                disabled={newpassword.length === 0 || confirm.length === 0
                                    || newpassword.length < 7 || confirm.length < 7}
                                type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                                <i className={`${loading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle mr-2 ml-2"`}></i>ثبت
                            </button>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
        </Row>
    )
}